<template>
    <div v-show="prop_alert_show">
        <div v-if="prop_alert_modal">
            <v-row justify="center">
                <v-dialog v-model="prop_alert_show" persistent max-width="360">
                    <v-card>
                        <v-card-title class="headline">
                            <div v-bind:class="'alert alert-'+prop_alert_type">
                                {{prop_alert_heading}}
                            </div>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <div v-bind:class="'alert alert-'+prop_alert_type">
                                {{prop_alert_message}}
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <router-link to="">Reload Page</router-link>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </div>
        <div v-else>
            <div v-bind:class="'alert alert-'+prop_alert_type" style="text-align:center;">
                <h4><strong>{{prop_alert_heading}}</strong></h4>
                <h4>{{prop_alert_message}}</h4>
            </div>
        </div>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default{
    name: 'ComponentAlertFlash',

    props:{
        prop_alert_show:Boolean,
        prop_alert_modal:Boolean,
        prop_alert_type:String,
        prop_alert_heading:String,
        prop_alert_message:String
    },

    components:{
    },

    data:function()
    {
        return{
        }
    },
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################

</script>
